<!-- TODO remove implementation-dependent stuff after list ops re-working is done! -->
<div
	class="filterListWrapper"
	[ngClass]="{
		'd-flex flex-column': !sidebar,
		'row mx-0': sidebar
	}"
>
	<div
		*ngFor="let item of defaultFilterData.items"
		class="filterList fs-md"
		[ngClass]="{
			'm-1 py-1 px-2 col text-center': sidebar
			}"
		[ngbTooltip]="
			sidebar
			? getI18nString( false, item?.i18nPath )
			: null
		"
		openDelay="1000"
	>
		<!-- checkbox + label (not rendered in sidebar) -->
		<app-checkbox
			*ngIf="!sidebar"
			[label]="getI18nString( false, item?.i18nPath )"
			[checked]="checkFilterItemActiveState( item.value )"
			[verticalAlignment]="verticalAlignmentEnum.TOP"
			(checkedChange)="onListFilterChange( item.value )"
		></app-checkbox>

		<!-- label (sidebar only, rendered as pill therein) -->
		<span
			*ngIf="sidebar"
			class="fs-md label"
		>
			{{ getI18nString( false, item?.i18nPath ) }}
		</span>
	</div>
</div>
